import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AboutUsPage = () => (
  <div className="min-h-screen bg-white">
    <Navbar />

    <main id="main-content">
      {/* Hero */}
      <section
        className="relative pt-36 pb-20 bg-[#00213a] overflow-hidden"
      >
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0"
            style={{ height: '4rem', background: 'linear-gradient(to bottom, rgba(0,33,58,0) 0%, rgba(255,255,255,1) 100%)' }}
            aria-hidden="true"
          />

        <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
              <span className="text-sm font-semibold text-white tracking-tight">Joseph C. Lanzetta School</span>
            </div>
          </div>
          <h1 className="text-5xl lg:text-7xl font-semibold text-white mb-6 tracking-tight" style={{ letterSpacing: '-0.02em' }}>
            About PS 96
          </h1>
          <p className="text-2xl text-white/90 font-normal max-w-3xl leading-relaxed mx-auto">
            One community for 3K–8th grade, rooted in East Harlem.
          </p>
        </div>
      </section>

      {/* Section 1 — Welcome: image left, text right */}
      <section className="flex flex-col lg:flex-row min-h-[480px]">
        <div className="lg:w-1/2 h-64 lg:h-auto overflow-hidden">
          <img
            src="/assets/images/aboutus/1000013106.jpg"
            alt="Students at PS 96"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="lg:w-1/2 bg-[#00213a] flex items-center px-10 py-14 lg:px-16">
          <div className="max-w-lg">
            <p className="text-xs font-black uppercase tracking-[0.2em] text-[#fdbb2e] mb-3">Welcome</p>
            <h2 className="text-3xl lg:text-4xl font-semibold text-white mb-6 leading-tight" style={{ letterSpacing: '-0.02em' }}>
              One Community for 3K–8th Grade.
            </h2>
            <p className="text-white/80 leading-relaxed text-lg">
              At P.S. 96, we pride ourselves on being a warm and nurturing community where families have found a home for generations. Our small, close-knit environment allows us to know each student and their family personally, fostering a deep sense of belonging. We serve our community with dedication, ensuring that every parent and caregiver feels respected and valued.
            </p>
          </div>
        </div>
      </section>

      {/* Section 2 — Community: text left, image right */}
      <section className="flex flex-col-reverse lg:flex-row min-h-[480px]">
        <div className="lg:w-1/2 bg-white flex items-center px-10 py-14 lg:px-16">
          <div className="max-w-lg">
            <p className="text-xs font-black uppercase tracking-[0.2em] text-[#00213a] mb-3">Our Community</p>
            <h2 className="text-3xl lg:text-4xl font-semibold text-gray-900 mb-6 leading-tight" style={{ letterSpacing: '-0.02em' }}>
              Warm, Caring Schools with a Deep Respect for Students and Families.
            </h2>
            <p className="text-gray-600 leading-relaxed text-lg mb-6">
              Our dual-language program in English and Spanish enriches our students' learning experiences, promoting cultural understanding and collaboration. With attentive teachers and a caring staff, we create an atmosphere filled with loving kindness and open communication.
            </p>
            <a
              href="/dual_language_programs"
              className="inline-flex items-center gap-2 px-5 py-2.5 border-2 border-[#00213a] text-[#00213a] font-semibold text-sm rounded-lg hover:bg-[#00213a] hover:text-white transition-colors duration-200"
            >
              Learn About Dual Language
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
          </div>
        </div>
        <div className="lg:w-1/2 h-64 lg:h-auto overflow-hidden">
          <img
            src="/assets/images/aboutus/IMG_8856.jpeg"
            alt="PS 96 community"
            className="w-full h-full object-cover"
          />
        </div>
      </section>

      {/* Section 3 — Mission: image left, text right */}
      <section className="flex flex-col lg:flex-row min-h-[480px]">
        <div className="lg:w-1/2 h-64 lg:h-auto overflow-hidden">
          <img
            src="/assets/images/aboutus/prek-art-project.jpg"
            alt="A young PS 96 student in a black hoodie glues colorful dots onto a paper art project at a classroom table"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="lg:w-1/2 bg-[#fdbb2e] flex items-center px-10 py-14 lg:px-16">
          <div className="max-w-lg">
            <p className="text-xs font-black uppercase tracking-[0.2em] text-[#00213a] mb-3">Our Mission</p>
            <h2 className="text-3xl lg:text-4xl font-semibold text-[#00213a] mb-6 leading-tight" style={{ letterSpacing: '-0.02em' }}>
              Nothing Less Than Greatness.
            </h2>
            <p className="text-[#00213a]/80 leading-relaxed text-lg mb-6">
              At PS 96 we believe that all students have the ability to achieve high academic success. Through personalized instruction, frequent checks of student understanding, and high levels of student engagement, we ensure our students are prepared for success in high school, college, and their career endeavors.
            </p>
            <a
              href="/mission-statement"
              className="inline-flex items-center gap-2 px-5 py-2.5 border-2 border-[#00213a] text-[#00213a] font-semibold text-sm rounded-lg hover:bg-[#00213a] hover:text-white transition-colors duration-200"
            >
              Read Our Full Mission
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* Section 4 — Small Community: text left, image right */}
      <section className="flex flex-col-reverse lg:flex-row min-h-[480px]">
        <div className="lg:w-1/2 bg-[#00213a] flex items-center px-10 py-14 lg:px-16">
          <div className="max-w-lg">
            <p className="text-xs font-black uppercase tracking-[0.2em] text-[#fdbb2e] mb-3">Small Learning Community</p>
            <h2 className="text-3xl lg:text-4xl font-semibold text-white mb-6 leading-tight" style={{ letterSpacing: '-0.02em' }}>
              We Know Every Student by Name.
            </h2>
            <p className="text-white/80 leading-relaxed text-lg mb-6">
              We are a small learning community that recognizes the inherent struggles that face our students each day — and yet we will not offer any excuses for not reaching the highest achievement levels. We will settle for nothing less than greatness for each and every student educated in our classrooms.
            </p>
            <a
              href="/principal-message"
              className="inline-flex items-center gap-2 px-5 py-2.5 border-2 border-white text-white font-semibold text-sm rounded-lg hover:bg-white hover:text-[#00213a] transition-colors duration-200"
            >
              Message from Our Principal
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
          </div>
        </div>
        <div className="lg:w-1/2 h-64 lg:h-auto overflow-hidden">
          <img
            src="/assets/images/aboutus/B50CE4E6-D3B9-497D-BC05-4F4999D6B88E.jpeg"
            alt="PS 96 students"
            className="w-full h-full object-cover"
          />
        </div>
      </section>
    </main>

    <Footer />
  </div>
);

export default AboutUsPage;
